import React from "react";
import { Col, Row, Select } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import CustomSelect from "../../../../../../common/input/custom-select/custom-select";
import { City, Country, State } from "country-state-city";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";

const StudentContactInformation = ({ control, watch, resetField }) => {
  const selectedCountry = watch("country");
  const selectedProvince = watch("province");
    const selectedCountryIsoCode = Country.getAllCountries().find(
    (c) => c.name === selectedCountry
  )?.isoCode;
  const selectedProvinceIsoCode = State.getStatesOfCountry(selectedCountryIsoCode).find(
    (s) => s.name === selectedProvince
  )?.isoCode;

  return (
    <Row gutter={[32, 20]}>
      <Col span={12}>
        <Controller
          name="email"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="email"
              label="Email"
              showOptional
              type="email"
              labelColor="#171717"
              placeholder="Enter email"
              size="large"
              value={value}
              prefix={
                <MailOutlined style={{ color: "#999999", paddingRight: 4 }} />
              }
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="phone"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="phone"
              label="Phone Number"
              showOptional
              labelColor="#171717"
              placeholder="Enter phone number"
              type="number"
              size="large"
              value={value}
              prefix={
                <PhoneOutlined style={{ color: "#999999", paddingRight: 4 }} />
              }
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="country"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomSelect
              id="country"
              label="Select Country"
              showOptional
              labelColor="#171717"
              placeholder="--Select--"
              showSearch={true}
              size="large"
              value={value}
              onChange={(...args) => {
                resetField("province");
                resetField("city");
                onChange(...args);
              }}
              status={error ? "error" : ""}
            >
              {Country?.getAllCountries()?.map((item) => (
                <Select.Option key={item?.isoCode} value={item?.name}>
                  {item?.name}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="province"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomSelect
              id="province"
              label="Select Province/State"
              showOptional
              labelColor="#171717"
              placeholder="--Select--"
              showSearch={true}
              size="large"
              value={value}
              onChange={(...args) => {
                resetField("city");
                onChange(...args);
              }}
              status={error ? "error" : ""}
            >
              {State?.getStatesOfCountry(selectedCountryIsoCode)?.map((item) => (
                <Select.Option key={item?.isoCode} value={item?.name}>
                  {item?.name}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="city"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomSelect
              id="city"
              label="Select City"
              showOptional
              placeholder="--Select--"
              showSearch
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            >
              {City?.getCitiesOfState(
                selectedCountryIsoCode,
                selectedProvinceIsoCode
              )?.map((item) => (
                <Select.Option key={item?.name} value={item?.name}>
                  {item?.name}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="address"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="address"
              label="Street Address"
              showOptional
              labelColor="#171717"
              placeholder="Enter name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="emergency_contact_number"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="emergency_contact_number"
              label="Emergency Contact Number"
              showOptional
              labelColor="#171717"
              placeholder="Enter Phone Number"
              type="number"
              size="large"
              value={value}
              prefix={
                <PhoneOutlined style={{ color: "#999999", paddingRight: 4 }} />
              }
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="emergency_contact_person"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="emergency_contact_person"
              label="Emergency Contact Person"
              showOptional
              labelColor="#171717"
              placeholder="Enter name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default StudentContactInformation;
